<template>
    <div class="container my-4">

        <div v-if="posts_main.length > 0" class="featured-image-grid mb-4">
            <div v-for="(item, index) in posts_main" :key="index" class="grid-item" :style="`background-image: url('${item.image}')`">
            <!-- <div v-for="(item, index) in posts_main" :key="index" class="grid-item"> -->
                <router-link :to="{ 'name': 'post_detail', params: { id: item.id } }" class="d-flex1 align-items-center1 nav-link featured-image">
                    <!-- <img :src="item.image" /> -->
                    <div class="overlay">
                        <div class="small mb-sm-2 post-dash-datetime" v-html="G.dateToStr(item.create_date, 'news_date', 'datetime')"></div>
                        <div class="post-dash-title mb-sm-2" :class="index == 0 ? 'h4' : 'h6'" v-html="item.translate && item.translate[0].title"></div>
                        <div class="post-dash-short" v-if="index == 0" v-html="item.translate && item.translate[0].short"></div>
                        <!-- <div class="post-dash-title mb-sm-2" :class="index == 0 ? 'h4' : 'h6'" v-html="item.translate ? (item.translate[0].title.length > 150 ? item.translate[0].title.substring(0, 150) + '...' : item.translate[0].title) : ''"></div>
                        <div class="post-dash-short" v-if="index == 0" v-html="item.translate ? (item.translate[0].short.length > 80 ? item.translate[0].short.substring(0, 80) + '...' : item.translate[0].short) : ''"></div> -->
                    </div>
                </router-link>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-lg-8 posts">
                <!-- <Loading v-if="loading" /> -->

                <div class="vector-header vector-header-wide fw-semibold mb-4" style="--h: 60px">
                    <div class="row m-0 w-100">
                        <div class="col ps-sm-4 blog-items-title">{{ TR.techno_news }}</div>
                    </div>
                </div>

                <BlogItem v-for="(post, index) in posts" :key="index" :data="post" :lang="TR" />
            </div>

            <div class="col-lg-4">
                <HomeSidebar :data="authors" />
            </div>
        </div>

        <!-- <div class="row1 g-31"> -->
            <Pagination
                v-if="posts.length"
                :row_count="totalrecords"
                :pages_count="pages_count"
                :lang="TR"
                :current_page="current_page"
                :perpage="perpage"
                :page_row_count="G.rowsPerPageOptions"
                @navigate="pagenav"
                class="pagenav mt-3"
            />
        <!-- </div> -->

    </div>

</template>


<script>
import { onBeforeMount, ref, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useStore } from "@/system_modules/store";

import BlogItem from '@/pages/component/BlogItem.vue';
import HomeSidebar from '@/pages/component/HomeSidebar.vue';
// import Loading from '@/components/elements/Loading.vue';
import Pagination from '@/components/elements/Pagination.vue';

import { G, ajax } from '@/_common';


export default {
    title: 'Ana səhifə',
    name: 'HomeP',
    components: {
        BlogItem,
        HomeSidebar,
        // Loading,
        Pagination,
    },
    props: {
        data: {
            type: Object,
            default: () => { }
        },
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();

        const TR = ref({});

        const authors = ref([]);
        const author = ref({});
        const posts = ref([]);
        const posts_main = ref([]);
        const categories = ref([]);

        // const loading = ref(true);
        const pages_count = ref(0);
        const current_page = ref(null);
        const perpage = ref(G.rowsPerPage);
        const totalrecords = ref(0);
        const search_text = ref('');

        const category_id = ref(0);
        // const rowperpage = ref(20);
        const route_obj = ref({});
        // const selectedFilters = ref({});
        // const selectedSortField = ref("create_date");
        // const selectedSortOrder = ref(-1);

        // const navigate = async (categoryId) => {
        //     // currentSection.value = categoryId;
        //     selectedCategory.value = categoryId;
        //     // toggleSidebar();
        //     sidebarCollapsed.value = false;
        //     // loadProducts();
        //     current_page.value = 1;
        //     await getProducts(categoryId);
        // };

        const page = route.params && route.params.page ? parseInt(route.params.page) : 1;
        category_id.value = route.params && route.params.category_id ? parseInt(route.params.category_id) : 0;
        perpage.value = route.params && route.params.perpage ? parseInt(route.params.perpage) : G.rowsPerPage;
        search_text.value = route.query && route.params.search_text ? route.params.search_text : '';

        // selectedSortField.value = route.params.sortfield || "create_date";
        // selectedSortOrder.value = parseInt(route.params.sortorder || -1);

        current_page.value = page;

        const pagenav = async (p, pp) => {
            perpage.value = pp;
            // if (search_text.value != '')
            //     await getPosts(p);
            // else
                await getPosts(p);

            router.push({ name: 'post_paging', params: route_obj.value });
        }

        const searchCallback = (event) => {
            if (event.which == 13 || event.which == 1) {
                current_page.value = 1;
                getPosts(1);
            }
        };

        const getPosts = async (first) => {
            route_obj.value = {
                // params: {
                page: first,
                perpage: perpage.value,
                category_id: parseInt(category_id.value) || 0,
                // author_id: 0,
                // sortfield: selectedSortField.value,
                // sortorder: selectedSortOrder.value,
                // filters: Object.keys(selectedFilters.value).filter((k) => selectedFilters.value[k] == true).join(',') || '0',
                search_text: search_text.value || '',
                // },
                // query: {
                // 	search_text: search_text.value || '',
                // }
            };
            // if( search_text.value ){
            //     route_obj.value['search_text'] = search_text.value;
            // }
            // if( first === undefined )
            // {
            //     first = 1;

            // }
        };

        watchEffect(() => {
            TR.value = store.getTranslation();
            // posts_main.value.forEach(d => d.create_date = G.dateToStr(moment(d.create_date, G.datetime_format['datetime']).format(G.datetime_format['datetime_as_pg']), 'news_date'));
        });

        onBeforeMount(async () => {
            await getPosts(page);

            await ajax({
                // loading: true,
                url: store.getPostsMain(), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
                success: (e) => {
                    posts_main.value = e.data.data;
                    // totalrecords.value = e.data.total_records;
                    // pages_count.value = Math.ceil(e.data.total_records / perpage.value);
                }
            });

            await ajax({
                loading: true,
                url: store.getPostPaging(route_obj.value), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
                success: (e) => {
                    posts.value = e.data.data; //.filter(f => f.main_status != 1 );
                    totalrecords.value = e.data.total_records;
                    pages_count.value = Math.ceil(totalrecords.value / perpage.value);
                }
            });

            await ajax({
                url: store.getAuthor(),
                success: (e) => {
                    authors.value = e.data.data;
                }
            });
        });

        return {
            G,
            TR,

            // loading,
            pages_count,
            current_page,
            perpage,
            totalrecords,
            // navigate,
            pagenav,
            searchCallback,
            search_text,

            categories,
            authors,
            posts,
            posts_main,
            author,
        };
    },
}
</script>


<style lang="scss">
// :root {
//     --primary-color: #D32F2F;
//     --secondary-color: #FBC02D;
//     --background-color: #FAFAFA;
//     --header-background: #FFFFFF;
//     --footer-background: #212121;
//     --text-color: #212121;
//     --muted-text-color: #757575;
//     --card-border-color: #EEEEEE;
// }

.posts {
    .card {
        border: 1px solid var(--card-border-color);
        // border-radius: 1rem;
        transition: box-shadow .3s;
    }

    .card:hover {
        box-shadow: 0 0 21px rgba(33, 33, 33, .2);
        cursor: pointer;
        scale: 1.01;
    }

    .card a {
        color: rgb(var(--site-primary-color-rgb));
    }
}

.featured-image-grid {
    display: grid;
    gap: .5rem;
    height: clamp(23rem, 23vw, 50rem);
    // clamp(1.125rem, 1.0815rem + 0.2174vi, 1.25rem);
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(4, 1fr);
}
.featured-image-grid .grid-item:first-child {
    grid-row: 1 / 3;
    grid-column: 1 / 3;
}
.featured-image-grid .grid-item{
    border-radius: 20px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.featured-image {
    position: relative;
    overflow: hidden;
    border-radius: 1rem;
    height: 100%;
}
.featured-image > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.featured-image .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
    color: #fff;
    padding: .8rem 1rem;
}
.featured-image .overlay .h4 {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: .4rem;
    line-height: 1.2;
}

// .active-item{
//     // border: 3px solid rgba(var(--bs-primary-rgb), .5);
//     border-radius: 10px;
//     box-shadow:
//         0px 0px 0px 5px rgba(228, 25, 25, 0.5),
//         0 0 0 1px rgba(211, 27, 27, 0.5);
// }
// .pagenav{
//     background: var(--background-gradient);
//     border-radius: 10px;
// }

.post-datetime {
    display: block;
}
.post-dash-title.h4{
    // white-space: nowrap; /* Prevents the text from wrapping to a new line */
    display: -webkit-box;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
}
.post-dash-title.h6{
    font-size: .85rem;
    font-weight: 500;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
}
.post-dash-short{
    font-size: .9rem;
    font-weight: 500;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
}


@media (min-width: 577px) and (max-width: 820px) {
    .featured-image-grid{
        height: clamp(45rem, 40vw, 60rem);
        grid-template-rows: repeat(4, 1fr);
        grid-template-columns: repeat(2, 1fr);
    }
}

@media(max-width: 576px) {
    .featured-image-grid {
        height: clamp(29rem, 35vw, 45rem);
        grid-template-rows: repeat(4, 1fr);
        grid-template-columns: repeat(2, 1fr);
    }
    .post-dash-datetime {
        display: none;
    }
    .blog-items-title{
        font-size: 18px;
    }
}

// @media only screen and (orientation: landscape)

// @media (min-width: 600px) {
//   .header {grid-area: 1 / span 6;}
//   .menu {grid-area: 2 / span 1;}
//   .content {grid-area: 2 / span 4;}
//   .facts {grid-area: 2 / span 1;}
//   .footer {grid-area: 3 / span 6;}
// }

</style>
